import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-circle-s",
  "use": "icon-check-circle-s-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-check-circle-s\"><path fill-rule=\"evenodd\" d=\"M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm4.751 7.408l-5.17 7.17a.78.78 0 01-1.27 0l-3.062-4.243a.197.197 0 01.16-.312H8.56c.25 0 .489.12.636.326l1.748 2.426 3.86-5.352a.785.785 0 01.636-.327h1.152c.16 0 .252.182.16.312z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol